import { render, staticRenderFns } from "./m-section-header-v2.vue?vue&type=template&id=0b69bd3a&scoped=true"
import script from "./m-section-header-v2.vue?vue&type=script&lang=js"
export * from "./m-section-header-v2.vue?vue&type=script&lang=js"
import style0 from "./m-section-header-v2.vue?vue&type=style&index=0&id=0b69bd3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b69bd3a",
  null
  
)

export default component.exports